import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16 4.706L15.294 4 10 9.294 4.706 4 4 4.706 9.294 10 4 15.294l.706.706L10 10.706 15.294 16l.706-.706L10.706 10z',
  ],
  height: 20,
  width: 20,
});
